import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { MEntradaNumerica } from "@/components/Gerais"
  import { computed } from "vue"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { Anulavel } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    modelValue: Anulavel<number>
    desativado?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OHoras',
  props: {
    modelValue: null,
    desativado: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: number): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: Anulavel<number>
    desativado?: boolean
  }

  const VALOR_MAXIMO_DE_HORAS = 999
  const VALOR_MAXIMO_DE_MINUTOS = 59
  const VALOR_MINIMO_DE_HORAS = 0
  const VALOR_MINIMO_DE_MINUTOS = 0

  const { t } = useI18n()

  

  const { recuperarHorasDaDuracao, recuperarMinutosDaDuracao } = usarDataHora()

  

  const emitirHoras = computed({
    get() {
      return recuperarHorasDaDuracao(props.modelValue!)
    },
    set(duracao: number) {
      const valorDeHorasEntradoEmMinutos = converterHorasEmMinutos(duracao)
      const valorDosMinutosOriginal = recuperarMinutosDaDuracao(
        props.modelValue!
      )
      const valorDeHorasTotalEmMinutos =
        valorDeHorasEntradoEmMinutos + valorDosMinutosOriginal

      emitir("update:modelValue", valorDeHorasTotalEmMinutos)
    },
  })

  const emitirMinutos = computed({
    get() {
      return recuperarMinutosDaDuracao(props.modelValue!)
    },
    set(duracao: number) {
      const valorDosMinutosOriginal = converterHorasEmMinutos(
        recuperarHorasDaDuracao(props.modelValue!)
      )
      const novoValorDeMinutosEntrado = duracao + valorDosMinutosOriginal

      emitir("update:modelValue", novoValorDeMinutosEntrado)
    },
  })

  const converterHorasEmMinutos = (horas: number) => {
    return horas * 60
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OHoras", { 'OHoras--desativado': __props.desativado }]),
    "data-testid": "OHoras"
  }, [
    _createVNode(_unref(MEntradaNumerica), {
      modelValue: _unref(emitirHoras),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirHoras) ? (emitirHoras).value = $event : null)),
      id: "OHoras__Horas",
      class: "OHoras__Valor",
      combinado: false,
      desativado: __props.desativado,
      "fator-incremento": 1,
      "id-para-testes": "OHoras__Horas",
      max: VALOR_MAXIMO_DE_HORAS,
      min: VALOR_MINIMO_DE_HORAS,
      nome: "horas",
      placeholder: "hh",
      sufixo: "h"
    }, null, 8, ["modelValue", "desativado"]),
    _createElementVNode("span", null, _toDisplayString(_unref(t)('e')), 1),
    _createVNode(_unref(MEntradaNumerica), {
      modelValue: _unref(emitirMinutos),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(emitirMinutos) ? (emitirMinutos).value = $event : null)),
      id: "OHoras__Minutos",
      class: "OHoras__Valor",
      combinado: false,
      desativado: __props.desativado,
      "fator-incremento": 1,
      "id-para-testes": "OHoras__Minutos",
      max: VALOR_MAXIMO_DE_MINUTOS,
      min: VALOR_MINIMO_DE_MINUTOS,
      nome: "minutos",
      placeholder: "mm",
      sufixo: "m"
    }, null, 8, ["modelValue", "desativado"])
  ], 2))
}
}

})